/* Progressive enhancement: the original SVG remains available without JavaScript. */
(() => {
  if (!customElements.get('eu-legal-guarantee-link')) {
    customElements.define('eu-legal-guarantee-link', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const link = this.querySelector('a');
        if (!link) return;
        link.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const dialog = document.getElementById('EULegalGuaranteeDialog');
          if (!dialog || typeof dialog.show !== 'function') return;
          event.preventDefault();
          dialog.show(link);
        });
        customElements.whenDefined('eu-legal-guarantee-dialog').then(() => {
          if (!link.isConnected || !document.getElementById('EULegalGuaranteeDialog')) return;
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', 'EULegalGuaranteeDialog');
        });
      }
    });
  }

  if (!customElements.get('eu-legal-guarantee-viewer')) {
    customElements.define('eu-legal-guarantee-viewer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('.eu-guarantee-viewer__fit');
        const viewport = this.querySelector('.eu-guarantee-viewer__viewport');
        if (!button || !viewport) return;
        button.hidden = false;
        button.addEventListener('click', () => {
          const zoomed = this.toggleAttribute('data-zoomed');
          button.setAttribute('aria-pressed', String(zoomed));
          button.textContent = zoomed ? 'Gesamtansicht' : 'Vergrößern';
          viewport.scrollTo(0, 0);
        });
      }
    });
  }

  customElements.whenDefined('modal-dialog').then(() => {
    if (customElements.get('eu-legal-guarantee-dialog')) return;
    const DawnModalDialog = customElements.get('modal-dialog');
    customElements.define('eu-legal-guarantee-dialog', class extends DawnModalDialog {
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.dataset.section = 'eu-legal-guarantee';
        if (this.parentElement !== document.body) document.body.appendChild(this);
      }

      show(opener) {
        this.parentDialog = opener.closest('quick-add-modal[open], modal-dialog[open]');
        super.show(opener);
        // Start on the first control so Shift+Tab is trapped on the first keypress, too.
        trapFocus(this.querySelector('[role="dialog"]'), this.querySelector('.eu-guarantee-modal__close'));
        this.querySelector('.eu-guarantee-modal__body').scrollTo(0, 0);
      }

      hide() {
        const parentDialog = this.parentDialog;
        const opener = this.openedBy;
        super.hide();
        if (parentDialog?.isConnected && parentDialog.hasAttribute('open')) {
          document.body.classList.add('overflow-hidden');
          trapFocus(parentDialog, opener);
        }
        this.parentDialog = null;
      }
    });
  });
})();
